import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloFamily,cleanAloFamily } from '@/models/alo/AloFamily'
import { AloInscription } from '@/models/alo/AloInscription'
import { AloFamInscription } from '@/models/alo/AloFamInscription'
import { AloFamCarte } from '@/models/alo/AloFamCarte'
import { AloNewCarte } from '@/models/alo/AloNewCarte'
import { uuidv4 } from '@/utils/uuid'
import { Tickets } from '@/models/alo/Tickets'
import { CmdTickets } from '@/models/alo/CmdTickets'

export default {
  getAllFamily(): AxiosPromise<AlrContainer<Array<AloFamily>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/Family`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloFamily>>
      }]
    })
  },
  getFamily(id:number):AxiosPromise<AlrContainer<AloFamily>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/Family/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloFamily>
      }]
    })
  },
  saveFamily(family:AloFamily):AxiosPromise<AlrContainer<AloFamily>> {
    cleanAloFamily(family)
    if(family.id) {    
      return  apiHelpers.apiCall({ 
        url: `/webapi/Family/${family.id}`, 
        method: 'PUT',
        data: family,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloFamily>
        }]
      })    
    }
    else{
      const pass=uuidv4()      
      var userIdentity = { userEmail:'', userPass:pass , userNom:family.libelle,userPrenom:'', userNewPass:pass};
      return apiHelpers.apiCall({ 
        url: '/webapi/Authenticate/create-account', 
        method: 'POST',
        data:userIdentity,
        transformResponse: [function (data: string) {          
          return JSON.parse(data) as AlrContainer<AloFamily>
        }] 
      })
    }
  },
  deleteFamily(id:number):AxiosPromise<AlrContainer<AloFamily>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/Family/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloFamily>
      }]
    })
  },
  getTickets(payload:{famId:number,crsId:number}):AxiosPromise<AlrContainer<Tickets>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/Family/tickets`, 
      method: 'GET',
      params:payload,
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Tickets>
      }]
    })
  },
  getAllowedTickets(payload:{famId:number,crsId:number}):AxiosPromise<AlrContainer<Array<CmdTickets>>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/Family/allowed-tickets`, 
      method: 'GET',
      params:payload,
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<CmdTickets>>
      }]
    })
  },
  inscription(payload:{usrId:number,crsId:number,crwId:number}):AxiosPromise<AlrContainer<boolean>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/Family/inscription`, 
      method: 'POST',
      params:payload,
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<boolean>
      }]
    })
  },
  inscriptions(payload:{famId:number,all:boolean}):AxiosPromise<AlrContainer<Array<AloFamInscription>>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/Family/inscriptions`, 
      method: 'GET',
      params:payload,
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloFamInscription>>
      }]
    })
  },
  forfaits(payload:{famId:number,all:boolean}):AxiosPromise<AlrContainer<Array<AloFamCarte>>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/Family/forfaits`, 
      method: 'GET',
      params:payload,
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloFamCarte>>
      }]
    })
  },
  annule(isnId:number):AxiosPromise<AlrContainer<boolean>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/Family/annule/${isnId}`, 
      method: 'PUT',      
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<boolean>
      }]
    })
  },
  addCarte(payload:{famId:number,carte:AloNewCarte}):AxiosPromise<AlrContainer<boolean>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/Family/carte/${payload.famId}`, 
      method: 'POST',      
      data:payload.carte,
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<boolean>
      }]
    })
  },
  updateCarte(payload:{famId:number,carte:AloNewCarte}):AxiosPromise<AlrContainer<boolean>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/Family/carte/${payload.famId}`, 
      method: 'PUT',      
      data:payload.carte,
      transformResponse: [function (data:string) {            
        return JSON.parse(data) as AlrContainer<boolean>
      }]
    })
  },
}